module.exports = __webpack_public_path__ + "img/wave-card-backup.d13b8506.png";